import { DataHeader, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFuelCard extends Layout {
    dataheaderFuelCard: DataHeader;
    panelContent: Panel;
    panelRow1: Panel;
    panelRow2: Panel;
    sourceFuelCard: DataSource;
    textboxAccount: Textbox;
    textboxAssigneeType: Textbox;
    textboxCardNumber: Textbox;
    textboxChargeCode: Textbox;
    textboxDriverId: Textbox;
    textboxFuelExpenseId: Textbox;
    textboxFuelInterfaceId: Textbox;
    textboxPayeeId: Textbox;
    textboxStatus: Textbox;
    textboxSubAccount: Textbox;
    textboxTractorId: Textbox;
}
